'use strict';

/**
 * Top Button
 * @module
 */

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * old listener to close popup
 */

function scrollTo (offsetNumber) {
	let ofTop;
	if ($.isNumeric(offsetNumber)) {
		ofTop = offsetNumber;
	} else {
		ofTop = $(offsetNumber).offset().top;
	}

	$('html, body').stop().animate({
		scrollTop: ofTop
	}, 700);
}

(function ($) {
	let $topBtn = $('.js-top');
	let $chatBtn = $('.js-bwidget');
	let $window = $(window);

	$('.js-down').on('click', () => {
		scrollTo('.js-down-section');
	});

	$('.js-anchors').on('click', '.js-anchors-item', function () {
		scrollTo($(this).attr('href'));
	});

	$('.js-anchor').on('click', function () {
		scrollTo($(this).attr('href'));
	});

	$('.js-binotel').on('click', () => {
		$('#bingc-phone-button-tooltip').trigger('click');
	});

	$('body').on('click', '.js-mfp-close', () => {
		$.magnificPopup.close();
	});

	$chatBtn.on('touchend mouseleave mousedown', (e) => {
		if (e.type === 'touchend') {
			$chatBtn.toggleClass('is-open');
		}

		if (e.type === 'mouseleave') {
			$chatBtn.removeClass('is-open');
		}

		if (e.type === 'mousedown') {
			$chatBtn.addClass('is-open');
		}
	});

	$topBtn.on('click', () => {
		scrollTo(0);
	});

	$window.on('scroll', function () {
		if ($window.scrollTop() > 100) {
			$topBtn.addClass('is-visible');
		} else {
			$topBtn.removeClass('is-visible');
		}
	});
})(window.jQuery);



// WEBPACK FOOTER //
// ./src/js/_modules/buttons.js